module.exports = __webpack_public_path__ + "img/accpet-invite-error.ddba5d09.png";